import React from "react";
import CustomTemplates from "../../Deals/CustomTemplate";
import { littleDremers } from "../../../../components/template/CustomTemplate/Pages/littleDremers";

const LittleDremers = () => {
  return (
    <div>
      {" "}
      <CustomTemplates slug={"little-dreamers"} attributes={littleDremers} />
    </div>
  );
};

export default LittleDremers;
